/* USgovmint — nút "Add to Bag" (form[data-ug-add]: thẻ sản phẩm, ngăn Added to Bag…), không chuyển trang.
   Adding… → Added ✓ (1,2 giây) → trở lại. Báo cho Shopify/Horizon bằng đúng sự kiện chuẩn (CartLinesUpdateEvent):
   số trên icon giỏ tự cập nhật, rồi mở ngăn "Added to Bag" (assets/ug-added.js).
   Nghe 'submit' ở pha capture trên window để chặn TRƯỚC bộ theo dõi Web Pixels của Shopify —
   nếu không, Shopify đếm 2 lần AddToCart (1 do form submit, 1 do request /cart/add.js) → pixel Facebook bị trùng.
   Không có JS: form gửi bình thường tới /cart/add. */
const busy = new WeakSet();

async function cartEvent() {
  try { return (await import('@shopify/events')).CartLinesUpdateEvent || null; } catch (_) { return null; }
}

window.addEventListener('submit', async (e) => {
  const form = e.target instanceof HTMLFormElement && e.target.matches('form[data-ug-add]') ? e.target : null;
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  if (!btn || btn.disabled || busy.has(form)) return;
  busy.add(form);
  const label = btn.querySelector('[data-label]') || btn;
  const T = btn.dataset;
  const msg = form.querySelector('[data-msg]');
  if (msg) { msg.hidden = true; msg.textContent = ''; }
  btn.classList.add('is-busy');
  btn.setAttribute('aria-disabled', 'true');
  label.textContent = T.adding;
  const reset = (ms) => setTimeout(() => {
    label.textContent = T.add;
    btn.classList.remove('is-busy', 'is-done');
    btn.removeAttribute('aria-disabled');
    busy.delete(form);
  }, ms);
  const fail = (text) => {
    if (msg) { msg.textContent = text || T.error; msg.hidden = false; setTimeout(() => { msg.hidden = true; }, 8000); }
    reset(0);
  };

  const data = new FormData(form);
  const qty = Number(data.get('quantity')) || 1;

  const Ev = await cartEvent();
  const deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
  if (deferred) {
    form.dispatchEvent(new Ev({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: qty }],
      promise: deferred.promise,
    }));
  }
  const settle = (cart, detail) => {
    if (!deferred) return;
    let c;
    try { c = cart && Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : undefined; } catch (_) { c = undefined; }
    deferred.resolve({ cart: c, detail: Object.assign({ items: cart ? cart.items : [], source: 'ug-card', sourceId: form.id || '', productId: form.dataset.productId }, detail) });
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const getCart = () => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);

  try {
    const res = await fetch(form.action.replace(/\/$/, '') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
    });
    let json = {};
    try { json = await res.json(); } catch (_) {}
    if (!res.ok || json.status) {
      settle(await getCart(), { didError: true, itemCount: 0 });
      fail(json.description || json.message);
      return;
    }
    const cartNow = await getCart();
    settle(cartNow, { didError: false, itemCount: qty, sections: json.sections });
    label.textContent = T.added;
    btn.classList.add('is-done');
    reset(1200);
    // Mở ngăn "Added to Bag" (assets/ug-added.js); không có thì sang trang giỏ
    if (window.UGAdded) {
      window.UGAdded.open(json, cartNow, btn);
    } else {
      window.location.href = form.dataset.cartUrl || root + 'cart';
    }
  } catch (x) {
    settle(null, { didError: true, itemCount: 0 });
    fail();
  }
}, true);
